import {
  ADD_PRODUCT,
  ADD_QUANTITY,
  ADD_TO_CART,
  DELETE_PRODUCT_FROM_CART,
  REMOVE_QUANTITY,
} from "./actionTypes";

export const addproduct = (obj) => {
  return {
    type: ADD_PRODUCT,
    payload: obj,
  };
};

export const addtocart = (obj) => {
  return {
    type: ADD_TO_CART,
    payload: obj,
  };
};

export const incrementProductQuantity = (product_id) => {
  return {
    type: ADD_QUANTITY,
    payload: product_id,
  };
};

export const decrementProductQuantity = (product_id) => {
  return {
    type: REMOVE_QUANTITY,
    payload: product_id,
  };
};

export const deleteproductfromcart = (product_id) => {
  return {
    type: DELETE_PRODUCT_FROM_CART,
    payload: product_id,
  };
};
